export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOADING_POSTS = "LOADING_POSTS";
export const GET_POSTS = "GET_POSTS";
export const ADD_POST = "ADD_POST";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const GET_PROFILE = "GET_PROFILE";
export const FOLLOW = "FOLLOW";
export const UNFOLLOW = "UNFOLLOW";
export const LIKE_POST_SUCCESS = "LIKE_POST_SUCCESS";
export const UNLIKE_POST_SUCCESS = "UNLIKE_POST_SUCCESS";
export const LIKE_POST_ERROR = "LIKE_POST_ERROR";
export const UNLIKE_POST_ERROR = "UNLIKE_POST_ERROR";
export const POST_ERROR = "POST_ERROR";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_ERROR = "DELETE_POST_ERROR";
export const UPDATE_POST_ERROR = "UPDATE_POST_ERROR";
export const UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS";
export const TOGGLE_THEME = 'TOGGLE_THEME';
